import { useState } from 'react';

export default function StandardButton({
  onClick,
  children,
  dataCy,
  confirmDialog,
  disabled = false
}: {
  onClick: () => void;
  children: React.ReactNode;
  dataCy?: string;
  confirmDialog?: () => Promise<boolean>; // Optional confirmation function
  disabled?: boolean
}): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);

  function handleClick(): void {
    if (confirmDialog != null) {
      setIsLoading(true);
      confirmDialog()
        .then((isConfirmed) => {
          if (isConfirmed) {
            onClick();
          }
        })
        .catch((error) => {
          console.error('Error in confirmDialog:', error);
        })
        .finally(() => { setIsLoading(false); });
    } else {
      onClick();
    }
  }

  return (
    <button
      className={`btn border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm text-indigo-500 ${
      isLoading || disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      data-cy={dataCy}
      onClick={handleClick}
      disabled={isLoading || disabled}
    >
      {children}
    </button>
  );
}
